




























































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import {
  MedicalSpecification,
  SenmonModel
} from "@/components/medicalTransmissionEdit/types";
import EditMonthChangePicker from "@/components/common/EditMonthChangePicker.vue";
import EditDayChangePicker from "@/components/common/EditDayChangePicker.vue";
import NumberInput from "@/components/common/NumberInput.vue";
import { SelectItemString } from "@/types";
@Component({
  components: { EditMonthChangePicker, EditDayChangePicker, NumberInput }
})
export default class BasicInfo12 extends Vue {
  @Prop() tab!: MedicalSpecification;
  @Prop() specialty_training_codes!: SelectItemString[]; //専門の研修コード

  //削除
  private deleteRow(senmon: SenmonModel) {
    if (!confirm("削除します。よろしいですか？")) {
      return;
    }
    const senmons = this.tab.senmons.filter(s => s.idx != senmon.idx);
    //インデックスのリセット
    let idx = 0;
    for (const s of senmons) {
      s.idx = idx;
      idx++;
    }
    this.tab.senmons = senmons;
  }

  //専門行追加
  private addRow() {
    const senmon: SenmonModel = {
      idx: this.tab.senmons.length,
      senmon_div: "",
      manual_date: "",
      review_date: ""
    };
    this.tab.senmons.push(senmon);
  }
}
